<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Item</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = {};"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah Data Item Supplier' : 'Ubah Harga' }} 
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Item"
                    rules="required"  
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Pilih Supplier
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"

                      
                      rounded
                      dense
                      filled

                      :color="set_color"
                      placeholder="Contoh. Supplier"
                      :readonly="form.id !== ''"

                      hide-details

                      :items="form.id !== '' ? itemAll : item"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-on:change="selected.item = item.find(x => x.id === form.supplier_id)"

                      v-model="form.supplier_id"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.supplier_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <div v-if="Object.keys(selected.item).length > 0" class="mt-4">
                    <v-card flat 
                      style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                      <v-card-text
                        class="py-3 line-text-second">
                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">Nama</div> : {{ selected.item.name }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">Email</div> : {{ selected.item.email }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">Mobilephone</div> : {{ selected.item.mobilephone }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">PIC Nama</div> : {{ selected.item.pic_name }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">PIC Email</div> : {{ selected.item.pic_email }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">PIC Mobilephone</div> : {{ selected.item.pic_mobilephone }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 150px;">Alamat</div> : {{ selected.item.address }}
                        </div>
                        

                        <!-- <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                        </div> -->
                      </v-card-text>
                    </v-card>
                  </div>

                  <ValidationProvider
                    :name="`Harga Beli`" 
                    :rules="`required|min_value:0`" 
                    v-slot="{ errors }">
                    <div class="body-2 mb-2 mt-6">
                      <span class="red--text">*</span>

                      Harga Beli
                    </div>
                    <v-currency-field
                          
                      
                      rounded
                      dense
                      filled

                      color="#718EBF"
                      placeholder="Harga Beli"
                      :error-messages="errors"

                      

                      v-model="form.purchase_price"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.purchase_price !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row>
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="Object.keys(detail).length < 1"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="Object.keys(detail).length > 0"
                flat>
                <v-card-text class="px-0">
                  <v-row>
                    <v-col cols="6" class="fs-17 black_one font_weight_600">
                      Data Supplier
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                      <v-btn
                        @click="dialog.form = true; reset();"
                        color="#4B4B4B"
                        elevation="0"
                        class="body-2 white--text text-capitalize d-flex align-center"
                        style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                        <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                        
                        <span
                          class="ml-2">
                          Tambah
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>


                  <!-- <v-card-text v-if="list.length < 1"
                    class="pb-0 my-4" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="100"
                        :height="100"
                        :src="require('@/assets/image/empty.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <div 
                        class="font-weight-light text-second my-6"
                        :class="font">
                        Belum ada data
                      </div>
                    </div>
                  </v-card-text> -->
                  <v-row
                    class="pa-0 pb-0">
                    <v-col 
                      cols="12"
                      class="py-0">
                      <v-card 
                        flat
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-data-table
                            v-model="selected.row"
                            ref="table-grid"
                            class="table-grid"
                            :height="`calc(100vh - ${pagination.total_data > 0 ? '360px' : '248px'})`"
                            :show-select="checkbox"
                            :single-select="true"
                            :loading="process.load"
                            loading-text="Sedang memuat data . . ."
                            loader-height="5"
                            no-results-text="Belum ada data"
                            :options.sync="options"
                            :headers="configHeaders"
                            :items="list"
                            :items-per-page="100"
                            item-key="id"
                            @click:row="rowClick"
                            @toggle-select-all="handleToggleAll($event)"
                            @dblclick:row="doubleClick"
                            hide-default-footer>
                            <template
                              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                              v-slot:[`item.${header.value}`]="{ value, index }">
                              <div
                                v-bind:key="header.value">
                                <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                  {{ rowFormat(header.format, value) }} 
                                </div>
          
                                <div v-if="header.format === 'link'"
                                  class="cursor-pointer">
                                  
                                </div>
                  
                                <div v-if="header.format === 'regex'">
                                  <span
                                    class="two-line">
                                    {{ rowFormat(header.format, value) }}
                                  </span>
                                </div>
                  
                                <div v-if="header.format === 'image'"
                                  class="ma-4">
                                  <v-avatar
                                    size="60"
                                    tile
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <v-img 
                                      contain
                                      width="100%"
                                      height="100%"
                                      alt="POS Amanata" 
                                      :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                      class="ma-auto">
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height"
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            size="20"
                                            indeterminate 
                                            :color="set_color">
                                          </v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </v-avatar>
                                </div>
          
                                <div v-if="header.format === 'image_potrait'"
                                  class="ma-4">
                                  <v-img 
                                    contain
                                    width="100"
                                    height="125"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                    class="ma-auto"
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </div>
          
                                <div v-if="header.format === 'image_landscape'"
                                  class="ma-4">
                                  <v-img 
                                    contain
                                    width="200"
                                    height="125"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                    class="ma-auto"
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </div>
          
                                <div v-if="header.format === 'action'">
                                  <!-- <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        :to="`/master-pembelian/supplier-item/detail/${value}`"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        small
                                        rounded
                                        color="green"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-information-slab-circle-outline</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Detail</span>
                                  </v-tooltip> -->

                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="dialog.form = true; reset(index); "
          
                                        v-bind="attrs"
                                        v-on="on"
          
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="blue"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-square-edit-outline</v-icon>
                                      </v-btn>
                                    </template>
          
                                    <span>Ubah</span>
                                  </v-tooltip>
          
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="dialog.delete = true; selected.delete = index;"
          
                                        v-bind="attrs"
                                        v-on="on"
          
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>
          
                                    <span>Hapus</span>
                                  </v-tooltip>
                                </div>
          
                                <!-- <div v-if="header.format === 'bool'"
                                  class="d-flex align-center justify-center">
                                  <v-switch
                                    @change="toStatus(value, index)"
                                    v-model="value"
                                    color="success"
                                    class="ma-auto"
                                    hide-details>
                                  </v-switch>
                                </div> -->
          
                                <!-- <div v-if="header.format === 'status'"
                                  class="d-flex justify-center">
                                  
                                </div> -->
                              </div>
                            </template>
          
                            <template v-slot:[`item.index`]="{ index }">
                              {{ lastIndex + index }}
                            </template>
          
                            <v-progress-linear 
                              v-show="process.load" 
                              slot="progress" 
                              color="white" 
                              indeterminate>
                            </v-progress-linear>
                          </v-data-table>

                        <pagination v-if="pagination.total_data > 0"
                          @changePage="fetch($event)" 
                          @reloadPage="fetch($event)" 
                          :model="pagination" :display="paginationList"/>
                      </v-card>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="4" v-for="(item, index) in list" :key="index">
                      <v-card flat style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-card-text>
                          <div class="d-flex align-center">
                            <div class="fs-16 black_one font_weight_600">
                              Detail Supplier
                            </div>
                            <div class="ml-auto">
                              <v-btn
                                @click="dialog.delete = true; selected.delete = index;"
                                color="red"
                                icon
                                elevation="0"
                                class="body-2 white--text text-capitalize d-flex align-center">
                                <v-icon size="20">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </div>
                          <v-divider class="my-2"></v-divider>
                          <div>
                            <div>
                              Nama 
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.name }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div>
                              Email
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.email }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div>
                              Mobilephone
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.mobilephone }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div>
                              Nama PIC
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.pic_name }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div>
                              Email PIC
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.pic_email }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div>
                              Mobilephone PIC
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.pic_mobelphone }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div>
                              Alamat
                            </div>
                            <div class="fs-16 font_weight_600 black_one">
                              {{ item.address }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <iframe 
                              width="100%" 
                              height="250" 
                              frameborder="0" 
                              scrolling="no" 
                              marginheight="0" 
                              marginwidth="0" 
                              :src="`https://maps.google.com/maps?q=${item.latitude},${item.longitude}&hl=es&z=14&amp;output=embed`"
                              >
                            </iframe>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row> -->
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,

          form: false,
          delete: false
        },

        item: [],

        list_item: [],
        itemAll: [],

        checkbox: false,
        search: '',

        filter: {
          
        },

        selected: {
          row: [],
          freeze: [],
          reset: [],
          role: [],
          delete: 0,
          item: {}
        },

        role: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          supplier_id: '',
          item_id: '',
          purchase_price: 0
        },
        
        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    beforeMount () {
      // this.fetchDetail()
    },
    mounted () {
      // this.fetchItem()
      this.fetch()
      this.fetchItemAll()
    },
    methods: {
      // async fetch () {
      //   this.process.load = true
      //   let params = {
      //     limit: 100000000000,
      //     item_id: this.detail.id
      //   }

      //   await get(`pos/pembelian/item_supplier/data`, { params })
      //   .then(response => {
      //     let res = response.data
      //     this.process.load = false

      //     if (res.status === 200) {
      //       this.list = []
      //       res.results.data.map(x => {
      //         this.list_item.push({
      //           id_item_supplier: x.id,
      //         })
      //         this.fetchDetailItem(x.supplier_id)
      //       })
      //       this.fetchItem(res.results.data)
      //     }
      //   })
      // },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)

        this.expanded_program = []

        // this.expanded_kegiatan = []

        this.selected.row_kegiatan = []

        // this.selected.row_sub_kegiatan = []

        if (row.isExpanded) {
          const indexExpanded = this.expanded_program.findIndex(i => i === item)
          this.expanded_program.splice(indexExpanded, 1)
        } else {
          this.expanded_program.push(item)
        }
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },


      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          item_id: this.detail.id
          // outlet_id: this.outlet.outlet_id
        }

        this.selected.row = []

        await get(`pos/pembelian/item_supplier/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                // width: '120px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Supplier',
                width: '100%',
                value: 'supplier_name',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Nama Item',
              //   width: '100%',
              //   value: 'item_name_label',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Harga Beli',
                width: '200px',
                value: 'purchase_price',
                freeze: false,
                hide: false,
                format: 'number'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination
            this.fetchItem(res.results.data)

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      async fetchDetailItem (id) {
          let params = {
          id: id
        }

        await get(`pos/pembelian/supplier/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list.push(res.results.data)

            // this.list = this.list.map(x => {
            //   if (x.id === id) {
            //     x.name_label = x.name
            //     x.category_item_name = x.category_item_name
            //     x.satuan = x.satuan
            //     x.purchase_price = x.purchase_price
            //     x.desc = x.desc
            //     x.note = x.note
            //   }
            //   return x
            // })
            // let list = []

            // this.list.map((item) => {
            //   if (item.la)
            //   list.push({
            //     ...item,
            //     name_label: res.results.data.name_label,
            //     category_item_name: res.results.data.category_item_name,
            //     satuan: res.results.data.satuan,
            //     purchase_price: res.results.data.purchase_price,
            //     desc: res.results.data.desc,
            //     note: res.results.data.note,
            //     name: res.results.data.name
            //   })
            // })

            // this.list = list
          }
        })
      },
      async fetchItem (data) {
        let id  = []
        data.map(x => {
          id.push(x.supplier_id)
        })
        // console.log(id)
          let params = {
          limit: 100000000000,
          'id[nin]': id.toString()
        }

        await get(`pos/pembelian/supplier/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.item = res.results.data
          }
        })
      },

      async fetchItemAll () {
        // console.log(id)
          let params = {
          limit: 100000000000
        }

        await get(`pos/pembelian/supplier/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.itemAll = res.results.data
          }
        })
      },

      // reset () {
      //   this.form = {
      //     supplier_id: '',
      //     item_id: this.detail.id,
      //   }
      // },

      reset (index) {
        this.form = {
          id: index === undefined ? '' : this.list[index].id,
          item_id: this.detail.id,
          supplier_id: index === undefined ? '' : this.list[index].supplier_id,
          purchase_price: index === undefined ? 0 : this.list[index].purchase_price

        }
        if (index !== undefined) {
          this.selected.item = this.itemAll.find(x => x.id === this.form.supplier_id)

        } else {

          this.selected.item = {}
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          let url = this.form.id === '' ? 'pos/pembelian/item_supplier/add' : 'pos/pembelian/item_supplier/update'
          await post(url, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.fetch()
              this.dialog.form = false

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        // this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/pembelian/item_supplier/delete`, {
          data: {
            id: this.list_item[this.selected.delete].id_item_supplier
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.delete = {}
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>